import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { Link } from "react-router-dom";
import Logo from "../assets/logo.png";
import { AppBar, Drawer, ListItem, Toolbar } from "@material-ui/core";
import { TbWorld } from "react-icons/tb";
import { FaPhoneAlt } from "react-icons/fa";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
  root: {
    flexGrow: 1,
  },
  title: {
    flexGrow: 1,
  },
  appBarItems: {
    [theme.breakpoints.down("sm")]: {
      display: "none",
    },
  },
  mobileMenuButton: {
    marginRight: theme.spacing(2),
    [theme.breakpoints.up("sm")]: {
      display: "none",
    },
  },
  drawerIcon: {
    display: "none",
    [theme.breakpoints.down("sm")]: {
      display: "block",
    },
  },
  drawer: {
    width: 300,
  },
}));

const NewLanding = () => {
  const navigate = useNavigate();

  const [headerClass, setHeaderClass] = useState("main-header slide-header");
  const [logoClass, setLogoClass] = useState("logo-wrapper logo-slider");
  const [btnClass, setBtnClass] = useState("header-btn landing-header-btn");
  const [navLinkClass, setNavLinkClass] = useState("header_link hd_nav_link");
  const [navDivider, setNavDivider] = useState("nav-divider header_bars");

  useEffect(() => {
    const cameFromAbout = localStorage.getItem("cameFromAbout");
    if (cameFromAbout === "true") {
      setHeaderClass("main-header");
      setLogoClass("logo-wrapper");
      setBtnClass("header-btn");
      setNavLinkClass("hd_nav_link");
      setNavDivider("nav-divider");
      localStorage.removeItem("cameFromAbout");
    }
  }, []);

  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const handleMobileMenuOpen = () => {
    setMobileMenuOpen(true);
  };

  const handleMobileMenuClose = () => {
    setMobileMenuOpen(false);
  };

  const classes = useStyles();

  const [activeLink, setActiveLink] = useState("");
  const location = useLocation();

  useEffect(() => {
    const path = location.pathname.split("/").pop();
    setActiveLink(path);
  }, [location]);

  const isActive = (path) => {
    return activeLink === path ? "active-link" : "";
  };

  return (
    <div className="landing-bg">
      <div className={headerClass}>
        <header className="scrolled header-wrapper">
          <AppBar position="static" className="header_secondsec">
            <Toolbar className="container-fluid p-0 w-100 justify-content-between header_toolbar">
              <div className="hd_navigation">
                <div className="d-flex hd_nav_lft">
                  <Link className={logoClass}>
                    <img src={Logo} className="img-fluid" alt="logo" />
                  </Link>
                </div>

                <div className="hd_nav_links_cntr">
                  <Link
                    to="/about"
                    className={`${navLinkClass} ${isActive("about")}`}
                  >
                    About
                  </Link>
                  <Link
                    to="/services"
                    className={`${navLinkClass} ${isActive("services")}`}
                  >
                    Services
                  </Link>
                  <Link
                    to="/projects"
                    className={`${navLinkClass} ${isActive("projects")}`}
                  >
                    Projects
                  </Link>
                  <Link
                    to="/testimonials"
                    className={`${navLinkClass} ${isActive("testimonials")}`}
                  >
                    Testimonials
                  </Link>
                </div>

                <div className="rightside_menu">
                  <div className="header_btn_wrap">
                    <button
                      className={btnClass}
                      onClick={() => navigate("/contact-us")}
                    >
                      <span className="phone_icon">
                        <FaPhoneAlt />
                      </span>
                      <span>Contact</span>
                    </button>
                    <button
                      className={btnClass}
                      onClick={() =>
                        window.open("https://beleaftechnologies.com/", "_blank")
                      }
                    >
                      <span className="web_icon">
                        <TbWorld />
                      </span>
                      <span>Website</span>
                    </button>
                  </div>
                </div>

                <div className={navDivider} onClick={handleMobileMenuOpen}>
                  <i className="fa-solid fa-bars"></i>
                </div>
              </div>
            </Toolbar>
          </AppBar>

          <Drawer
            anchor="left"
            open={mobileMenuOpen}
            onClose={handleMobileMenuClose}
            className={`mobile-drawer ${classes.drawer} gr-mob_drawer`}
          >
            <div className={` ${classes.mobileMenu}`}>
              <div className="logo_new_sectio mobile_menu_icon">
                <div
                  className="mobile_logo_wrap"
                  // onClick={() => navigate("/")}
                >
                  <img src={Logo} alt="logo" />
                </div>
              </div>

              <div className="menu_statis">
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/about">
                    About
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/services">
                    Services
                  </Link>
                </ListItem>
                <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/projects">
                    Projects
                  </Link>
                </ListItem>
                {/* <ListItem button className="drawa">
                  <Link className="hd_nav_link" to="/testimonials">
                    Testimonials
                  </Link>
                </ListItem> */}

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() => navigate("/contact-us")}
                  >
                    <span className="phone_icon">
                      <FaPhoneAlt />
                    </span>
                    <span>Contact</span>
                  </button>
                </ListItem>

                <ListItem button className="drawa">
                  <button
                    className="header-btn"
                    onClick={() =>
                      window.open("https://beleaftechnologies.com/", "_blank")
                    }
                  >
                    <span className="web_icon">
                      <TbWorld />
                    </span>
                    <span className="">Website</span>
                  </button>
                </ListItem>
              </div>
            </div>
          </Drawer>
        </header>
      </div>

      <main className="header-wrapper landing-main">
        <h1 className="landing-title">
          Wide range of services for every industry
        </h1>
        <p className="landing-content">
          Beleaf Technologies delivers innovative solutions across industries,
          from blockchain to AI, helping businesses thrive in the digital age.
        </p>

        <div className="explore-btn-wrap">
          <div
            className="landing-explore-btn"
            onClick={() => navigate("/about")}
          >
            <i className="fa-solid fa-arrow-down"></i>
          </div>
          <p className="explore-btn-content" onClick={() => navigate("/about")}>
            Explore
          </p>
        </div>
      </main>
    </div>
  );
};

export default NewLanding;
